import {useState} from 'react'
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import HotelForm from "./HotelForm";
import styles from "../showName/EditShowName.module.scss";

const EditHotel = ({ hotel, setHotel, onUpdate }) => {
    const [open, setOpen] = useState(false);

    const handleOpen = () => {
        setOpen(true);
    }

    const handleClose = () => {
        setOpen(false);
    }

    return (
        <>
            <EditOutlinedIcon
                fontSize="small"
                onClick={handleOpen}
                className={`${styles.icon} m-1`}
            />
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
                <DialogTitle styles={`${styles.header} text-center`}>
                    Edit hotel
                </DialogTitle>
                <HotelForm
                    hotel={hotel}
                    setHotel={setHotel}
                    onCancel={handleClose}
                    onUpdate={onUpdate}
                />
            </Dialog>
        </>
    )
}

export default EditHotel
